import { TextField } from '@mui/material';

import styles from './TextInput.module.scss';
import { Props } from './TextInput.types';

export const TextInput = (props: Props) => {
  return <TextField className={styles.container} {...props} />;
};
